import { Link } from 'react-router-dom';

const footerLinks = {
  navigation: [
    { to: '/', label: '首页' },
    { to: '/category/movie', label: '电影' },
    { to: '/category/tv', label: '电视剧' },
    { to: '/category/anime', label: '动漫' },
    { to: '/category/variety', label: '综艺' },
    { to: '/about', label: '关于我们' },
  ],
  support: [
    { to: '/about', label: '常见问题' },
    { to: '/about', label: '联系我们' },
    { to: '/about', label: '用户反馈' },
    { to: '/about', label: '版权声明' },
  ],
  categories: [
    { to: '/category/movie', label: '动作电影' },
    { to: '/category/movie', label: '科幻大片' },
    { to: '/category/tv', label: '热门剧集' },
    { to: '/category/anime', label: '日本动漫' },
    { to: '/category/variety', label: '综艺节目' },
  ],
};

export default function Footer() {
  return (
    <footer className="bg-background-900">
      <div className="w-full px-4 md:px-6 py-14">
        <div className="flex flex-col lg:flex-row gap-10 lg:gap-0">
          <div className="lg:w-[380px] flex-shrink-0">
            <Link to="/" className="flex items-center gap-2 mb-4 cursor-pointer">
              <div className="w-9 h-9 flex items-center justify-center bg-primary-500 rounded-lg">
                <i className="ri-heart-fill text-background-50 text-lg"></i>
              </div>
              <span className="font-heading text-xl font-bold text-background-50">
                红桃影院
              </span>
            </Link>
            <p className="text-background-400 text-sm leading-relaxed mb-6">
              红桃影院是您的高清影视在线观看首选平台，提供海量电影、电视剧、动漫、综艺免费观看。无广告、高清流畅，随时随地畅享优质影视娱乐体验。
            </p>
            <div className="flex items-center gap-3">
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-lg bg-background-800 hover:bg-primary-500 transition-colors cursor-pointer" aria-label="微信">
                <i className="ri-wechat-line text-background-300 text-lg"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-lg bg-background-800 hover:bg-primary-500 transition-colors cursor-pointer" aria-label="微博">
                <i className="ri-weibo-line text-background-300 text-lg"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-lg bg-background-800 hover:bg-primary-500 transition-colors cursor-pointer" aria-label="QQ">
                <i className="ri-qq-line text-background-300 text-lg"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-lg bg-background-800 hover:bg-primary-500 transition-colors cursor-pointer" aria-label="邮箱">
                <i className="ri-mail-line text-background-300 text-lg"></i>
              </a>
            </div>
          </div>

          <div className="flex-1 grid grid-cols-1 sm:grid-cols-3 gap-8">
            <div>
              <h4 className="text-background-50 font-heading font-semibold text-base mb-4">
                <a href="/" className="hover:text-primary-400 transition-colors cursor-pointer">快速导航</a>
              </h4>
              <ul className="space-y-3">
                {footerLinks.navigation.map((link) => (
                  <li key={link.label}>
                    <Link to={link.to} className="text-background-400 hover:text-background-100 text-sm transition-colors cursor-pointer">
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
            <div>
              <h4 className="text-background-50 font-heading font-semibold text-base mb-4">
                <a href="/about" className="hover:text-primary-400 transition-colors cursor-pointer">帮助中心</a>
              </h4>
              <ul className="space-y-3">
                {footerLinks.support.map((link) => (
                  <li key={link.label}>
                    <Link to={link.to} className="text-background-400 hover:text-background-100 text-sm transition-colors cursor-pointer">
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
            <div>
              <h4 className="text-background-50 font-heading font-semibold text-base mb-4">
                <a href="/category/movie" className="hover:text-primary-400 transition-colors cursor-pointer">热门分类</a>
              </h4>
              <ul className="space-y-3">
                {footerLinks.categories.map((link) => (
                  <li key={link.label}>
                    <Link to={link.to} className="text-background-400 hover:text-background-100 text-sm transition-colors cursor-pointer">
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </div>

      <div className="border-t border-background-800">
        <div className="w-full px-4 md:px-6 py-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-background-500 text-xs">
            &copy; 2026 <strong>红桃影院</strong>. All rights reserved. 红桃影院官网 hongtao.tv
          </p>
          <div className="flex items-center gap-6">
            <a href="#" className="text-background-500 hover:text-background-300 text-xs transition-colors cursor-pointer">隐私政策</a>
            <a href="#" className="text-background-500 hover:text-background-300 text-xs transition-colors cursor-pointer">服务条款</a>
            <a href="#" className="text-background-500 hover:text-background-300 text-xs transition-colors cursor-pointer">版权声明</a>
          </div>
        </div>
      </div>
    </footer>
  );
}